export default __webpack_public_path__ + "img/sagoo/sagoo4_src.webp";